// Runtime loader for the backend API server.
// It reads a static file served by the browser (example: `public/dvrsm-intranet.env`).

const DEFAULT_API_SERVER = '192.168.254.123:8080';

let apiServerCache = null;
let configPromise = null;

function parseEnvLike(text) {
  const out = {};
  const lines = String(text).split(/\r?\n/);

  for (const rawLine of lines) {
    const line = rawLine.trim();
    if (!line || line.startsWith('#')) continue;

    const idx = line.indexOf('=');
    if (idx === -1) continue;

    const key = line.slice(0, idx).trim();
    let value = line.slice(idx + 1).trim();

    // Strip optional quotes: KEY="value" / KEY='value'
    if (
      (value.startsWith('"') && value.endsWith('"')) ||
      (value.startsWith("'") && value.endsWith("'"))
    ) {
      value = value.slice(1, -1).trim();
    }

    out[key] = value;
  }

  return out;
}

function normalizeServerValue(serverValue) {
  let v = String(serverValue || '').trim();
  if (!v) return '';

  // Accept both: "host:port" and "https://host:port"
  v = v.replace(/^https?:\/\//i, '');
  v = v.replace(/\/+$/, '');
  return v;
}

async function loadConfig() {
  // Keep the path list small and explicit.
  const candidateFiles = ['/dvrsm-intranet.env'];

  for (const filePath of candidateFiles) {
    try {
      const res = await fetch(filePath, { cache: 'no-store' });
      if (!res.ok) continue;

      const text = await res.text();
      const env = parseEnvLike(text);

      const raw = env.API_SERVER ?? env.apiServer;
      const normalized = normalizeServerValue(raw);
      if (normalized) return normalized;
    } catch {
      // Ignore and fallback
    }
  }

  return DEFAULT_API_SERVER;
}

export async function getApiServerValue() {
  if (apiServerCache) return apiServerCache;
  if (!configPromise) {
    configPromise = loadConfig().then((server) => {
      apiServerCache = server;
      return server;
    });
  }
  return configPromise;
}

export async function waitForApiServerInit() {
  await getApiServerValue();
  return apiServerCache;
}

